import { Grid, Card, CardHeader, CardContent, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Factory, HourglassBottom, Inventory2, CheckCircle } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { MiniBarChart } from '../../components/MiniBarChart';
import { StatusBadge } from '../../components/StatusBadge';
import { EmptyState } from '../../components/EmptyState';
import { productionPlansApi } from '../../api/production.api';

const num = (n = 0) => Number(n).toLocaleString('en-IN');

export function ProductionDashboardPage() {
  const dash = useQuery({ queryKey: ['production-plans', 'dashboard'], queryFn: () => productionPlansApi.dashboard() });
  const d = dash.data;
  const statusData = d ? Object.entries(d.byStatus).map(([label, value]) => ({ label: label.replace(/_/g, ' '), value, color: '#1e40af' })) : [];

  return (
    <>
      <PageHeader title="Production Dashboard" subtitle="Planning, daily commitment and handover health." />

      <Grid container spacing={2} mb={1}>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#1e40af" label="Total Plans" value={num(d?.totalPlans)} icon={<Factory />} hint={`${num(d?.pendingApproval)} awaiting approval`} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#0d9488" label="Planned Units" value={num(d?.totalPlanned)} icon={<Inventory2 />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#16a34a" label="Produced Units" value={num(d?.totalProduced)} icon={<CheckCircle />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#d97706" label="Pending Handovers" value={num(d?.pendingHandovers)} icon={<HourglassBottom />} /></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Plans by Status" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>{statusData.length ? <MiniBarChart data={statusData} valueFormatter={num} /> : <EmptyState title="No plans yet" dense />}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Recent Plans" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(d?.recent.length ?? 0) === 0 ? <EmptyState title="No plans yet" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Title</TableCell><TableCell align="right">Planned</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
                  <TableBody>
                    {(d?.recent ?? []).map((p) => (
                      <TableRow key={p.id} hover>
                        <TableCell>{p.planCode}</TableCell>
                        <TableCell>{p.title}</TableCell>
                        <TableCell align="right">{num(p.totalPlannedQty)}</TableCell>
                        <TableCell><StatusBadge status={p.status} /></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
